const MISMO_PRECIO_COSTS = { 3: 0.088, 6: 0.133, 9: 0.175, 12: 0.213 };

export function fmt2(n) {
	if (typeof n !== 'number' || isNaN(n)) return '0.00';
	return n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export function calculateSimulatorScenario({
	pais,
	site,
	usdcost,
	localcost,
	dolar,
	pvpdisbyte,
	pvpbuyer: pvpbuyerInput = 0,
	iva,
	ivaaplicado,
	shippingmode,
	freeshipping,
	basefreeshipping,
	freeshippingcostnoivac,
	melifeeadjperc,
	iibb,
	ica,
	basefixrate,
	basefixrate2,
	basefixrate3,
	freeshippingcostr = 0,
	cuotasMode = 'clasica',
	cuotasCant = 3,
}) {
	const costo = usdcost > 0 ? usdcost * dolar : (localcost > 0 ? localcost : 0);

	let varProyPriceNoIva;
	if (pais === 'ARGENTINA') {
		varProyPriceNoIva = pvpdisbyte / (1 + ivaaplicado);
	} else {
		varProyPriceNoIva = pvpdisbyte / (1 + iva);
	}

	const varProyMeliFeeAdjNoIva = (melifeeadjperc * pvpdisbyte) / (1 + iva);

	let varProyFreeShippingNoIva =
		shippingmode === 'me1' && !freeshipping
			? 0
			: pvpdisbyte >= basefreeshipping
			? freeshippingcostnoivac
			: 0;

	if (pais === 'MEXICO' && site === 'AMZN' && freeshipping === false) {
		varProyFreeShippingNoIva = 0;
	}

	let varProyFixRate;

	if (pvpdisbyte < basefreeshipping) {
		if (pais === 'COLOMBIA') {
			varProyFixRate =
				pvpdisbyte < 30000
					? basefixrate / (1 + iva)
					: basefixrate2 / (1 + iva);
		} else if (pais === 'ARGENTINA') {
			varProyFixRate =
				pvpdisbyte <= 15000
					? basefixrate / (1 + iva)
					: pvpdisbyte <= 25000
					? basefixrate2 / (1 + iva)
					: pvpdisbyte <= 33000
					? basefixrate3 / (1 + iva)
					: 0;
		} else if (pais === 'MEXICO') {
			varProyFixRate =
				pvpdisbyte < 99
					? basefixrate / (1 + iva)
					: pvpdisbyte <= 149
					? basefixrate2 / (1 + iva)
					: pvpdisbyte <= 299
					? basefixrate3 / (1 + iva)
					: 0;
		} else {
			varProyFixRate = basefixrate / (1 + iva);
		}
	} else {
		varProyFixRate = 0;
	}

	varProyFixRate = site === 'VTEX' ? 0 : varProyFixRate;

	// MEX/COL: el API ahora retorna freeshippingcostr como costo operativo
	// incluso cuando freeshipping=false, reemplaza las tarifas fijas
	if ((pais === 'MEXICO' || pais === 'COLOMBIA') && freeshippingcostr > 0 && !freeshipping) {
		varProyFixRate = freeshippingcostr / (1 + iva);
	}

	let cuotasRate = 0;
	if (cuotasMode === 'interes_bajo') cuotasRate = 0.05;
	else if (cuotasMode === 'mismo_precio') cuotasRate = MISMO_PRECIO_COSTS[cuotasCant] || 0;
	const varProyCuotasNoIva = (pvpdisbyte * cuotasRate) / (1 + iva);

	let varProyProfit =
		varProyPriceNoIva -
		varProyMeliFeeAdjNoIva -
		varProyFixRate -
		varProyFreeShippingNoIva -
		varProyCuotasNoIva -
		costo;

	if (pais === 'ARGENTINA') {
		const pvpIibbCalculated = varProyPriceNoIva * iibb;
		varProyProfit = varProyProfit - pvpIibbCalculated;
	}

	if (pais === 'COLOMBIA') {
		const pvpIcaCalculated = varProyPriceNoIva * ica;
		varProyProfit = varProyProfit - pvpIcaCalculated;
	}

	const pvpbuyer = pvpbuyerInput;

	const hasFreeShipping =
		shippingmode === 'me1' && !freeshipping
			? false
			: pvpdisbyte >= basefreeshipping;

	return {
		localcost: +costo.toFixed(2),
		margen: +((varProyProfit / varProyPriceNoIva) * 100).toFixed(2),
		roi: costo > 0 ? +((varProyProfit / costo) * 100).toFixed(2) : 0,
		profit: +varProyProfit.toFixed(2),
		pvpNoIva: +varProyPriceNoIva.toFixed(2),
		meliFeeNoIva: +varProyMeliFeeAdjNoIva.toFixed(2),
		freeShippingCost: +varProyFreeShippingNoIva.toFixed(2),
		fixRate: +varProyFixRate.toFixed(2),
		cuotasCosto: +varProyCuotasNoIva.toFixed(2),
		pvpbuyer: +pvpbuyer.toFixed(2),
		hasFreeShipping,
	};
}
